import React from 'react';
import styled, { keyframes } from 'styled-components/macro';
import RobotLogo from 'assets/logo-diet-s.png'

const LoaderBellsWrapper = styled.div`
  width: 100%;
  height: ${({ customHeight }) => customHeight || `100vh`};
  background: transparent;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`


const CircleSpin = styled.div`
  display: inline-block;
  margin: auto;
  width: ${({ theme }) => theme.loader.spinWidth};
  height: ${({ theme }) => theme.loader.spinHeight};
  border: ${({ theme }) => `${theme.loader.border} solid ${theme.colors.disabled}`};
  border-radius: 50%;
`
const Circle = styled.div`
position: relative;
  width: ${({ theme }) => theme.loader.spinWidth};
  height: ${({ theme }) => theme.loader.spinHeight};
    margin: auto;
    border-radius: ${({ theme }) => theme.loader.spincircleborderradius};
    &:after {
      content: " ";
      width: ${({ theme }) => theme.loader.spinWidth};
      height: ${({ theme }) => theme.loader.spinHeight};
      display: block;
      border-radius: 50%;
      border: ${({ theme }) => `${theme.loader.spinBorderWidth} solid ${theme.loader.spinBorderColor}`};
      position: relative;
      left: ${({ theme }) => `-${theme.loader.spinBorderWidth}`};
      top: ${({ theme }) => `-${theme.loader.spinBorderWidth}`};
      border-color: ${({ theme }) => `${theme.loader.spinBorderColor} transparent transparent`};
      animation: 0.8s ease-in-out infinite ${spinAnimation};
    }
`

const Logo = styled.img`
  width: calc(${({ theme }) => theme.loader.spinWidth} - 20px);
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
`

const LogoText = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  width: calc(${({ theme }) => theme.loader.spinWidth} - 16px);
  text-align: center;
  font-weight: 700;
  font-size: 12px;
  line-height: 1.5;
  color: #333;
`

const Loader = ({ noBg, customHeight }) => {
  // Tryb embed (z WordPressa): ukryj logo KetoSwitch, pokaż tekst w środku spinnera.
  const noLogo =
    typeof window !== 'undefined' && window.sessionStorage.getItem('ls_no_logo') === '1';
  const logoText =
    (typeof window !== 'undefined' && window.sessionStorage.getItem('ls_logo_text')) || '';

  return (
    <LoaderBellsWrapper noBg={noBg} customHeight={customHeight}>
      <CircleSpin>
        {noLogo ? <LogoText>{logoText}</LogoText> : <Logo src={RobotLogo} alt="" />}
        <Circle />
      </CircleSpin>
    </LoaderBellsWrapper>

  );
};

export default Loader;
